import { useEffect, useState } from 'react';

const DEFAULT_BOTTOM = 52;

function useElementBottom(targetSelector, defaultBottom = DEFAULT_BOTTOM) {
    const [bottom, setBottom] = useState(defaultBottom);

    useEffect(() => {
        if (!targetSelector) {
            setBottom(defaultBottom);
            return () => {};
        }

        let observer = null;
        let lastBottom = null;

        function updateBottom() {
            const el = document.querySelector(targetSelector);
            if (el) {
                const rect = el.getBoundingClientRect();
                if (rect.bottom !== lastBottom) {
                    lastBottom = rect.bottom;
                    setBottom(rect.bottom);
                }
            } else {
                setBottom(defaultBottom);
            }
        }

        updateBottom();

        const el = document.querySelector(targetSelector);
        if (el && window.ResizeObserver) {
            observer = new ResizeObserver(updateBottom);
            observer.observe(el);
        }

        window.addEventListener('resize', updateBottom);
        window.addEventListener('scroll', updateBottom, true);

        return () => {
            if (observer && el) observer.disconnect();
            window.removeEventListener('resize', updateBottom);
            window.removeEventListener('scroll', updateBottom, true);
        };
    }, [targetSelector]);

    return bottom;
}

export default useElementBottom;
